type FeatureId = `${'event' | 'dimension'}${'' | `:${number | string}`}`;

export function buildCacheKey(id: StaticPageID, feature?: FeatureId): string;
export function buildCacheKey(id: string, feature?: FeatureId): string;
export function buildCacheKey(id: string, feature?: string) {
  if (!id) {
    return null as never;
  }

  return [id, feature].filter(Boolean).join(':');
}

export function buildCacheKeyPredicate(id: string, feature?: FeatureId) {
  return (key: string) => key.startsWith([id, feature].filter(Boolean).join(':'));
}
